/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */
export var ERROR_SPACE = 'password_contains_space';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_NUMBERS = 'password_needs_number';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_SPECIAL_CHARACTER = 'password_needs_special_character';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_SMALL_LETTERS = 'password_needs_small_letter';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_CAPITAL_LETTERS = 'password_needs_capital_letter';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_TOO_SHORT = 'too_short';
/**
 * Creates validator for password
 *
 * @function password
 * @param {Object} options Configuration for password
 * @return {validator} password validator
 */

export default function password() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    strong: false
  },
      strong = _ref.strong;

  return function (value) {
    if (value && /\s/i.test(value)) return ERROR_SPACE;
    if (value && !/[a-z]+/.test(value)) return ERROR_SMALL_LETTERS;
    if (value && !/[0-9]+/.test(value)) return ERROR_NUMBERS;

    if (strong) {
      if (value && value.length < 8) return ERROR_TOO_SHORT;
      if (value && !/[A-Z]+/.test(value)) return ERROR_CAPITAL_LETTERS;
      if (value && !/[^0-9a-zA-Z]+/.test(value)) return ERROR_SPECIAL_CHARACTER;
    }

    return null;
  };
}